import { startOfHour, add } from "date-fns";
import { SLOT_TIME } from "../../../appointment-schedule.constants.js";
const createIntervalObject = (start, end, employeeReferenceId) => ({
  start,
  end,
  employeeReferenceId
});
const generateStandardIntervals = (startTime, endTime, employeeReferenceId) => {
  const intervals = [];
  let currentStart = startTime;
  while (currentStart < endTime) {
    const nextEnd = add(currentStart, { minutes: SLOT_TIME });
    if (nextEnd > endTime) {
      intervals.push(createIntervalObject(currentStart, endTime, employeeReferenceId));
      break;
    }
    intervals.push(createIntervalObject(currentStart, nextEnd, employeeReferenceId));
    currentStart = nextEnd;
  }
  return intervals;
};
const calculateNextQuarterHour = (firstHour, minutesInHour) => {
  if (minutesInHour < 15) {
    return add(firstHour, { minutes: 30 });
  } else if (minutesInHour < 30) {
    return add(firstHour, { minutes: 45 });
  } else if (minutesInHour < 45) {
    return add(firstHour, { minutes: 60 });
  } else {
    return add(firstHour, { minutes: 75 });
  }
};
const isVeryShortInterval = (start, end) => {
  return end.getTime() - start.getTime() < SLOT_TIME * 60 * 1e3;
};
const splitSlotsToIntervals = (date, employeeReferenceId) => {
  const intervals = [];
  const currentStart = date.start;
  const minutesInHour = currentStart.getMinutes();
  const isOnQuarterHour = minutesInHour % 15 === 0;
  if (isOnQuarterHour) {
    return generateStandardIntervals(currentStart, date.end, employeeReferenceId);
  } else {
    const firstHour = startOfHour(currentStart);
    if (isVeryShortInterval(date.start, date.end)) {
      intervals.push(createIntervalObject(currentStart, date.end, employeeReferenceId));
      return intervals;
    }
    let nextQuarterHour = calculateNextQuarterHour(firstHour, minutesInHour);
    if (nextQuarterHour > date.end) {
      nextQuarterHour = date.end;
    }
    intervals.push(createIntervalObject(currentStart, nextQuarterHour, employeeReferenceId));
    const remainingIntervals = generateStandardIntervals(nextQuarterHour, date.end, employeeReferenceId);
    return [...intervals, ...remainingIntervals];
  }
};
export {
  splitSlotsToIntervals
};
